<script setup>
import {computed} from "vue";
import moment from "moment";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  date: {
    type: String,
    required: true,
  }
})

const formattedDate = computed(() => moment(props.date).format('DD/MM/YYYY'));
</script>

<template>
  <div class="tw-w-full tw-flex tw-justify-between tw-items-center tw-p-8 tw-border tw-border-neutral-300 tw-rounded-xl">
    <div class="tw-text-base tw-font-bold tw-text-neutral-800 tw-truncate tw-min-w-0">
      {{ url }}
    </div>
    <div class="tw-flex tw-items-center tw-gap-3">
      <svg-vue
        class="tw-text-success tw-h-6"
        icon="icons/check-circle-thin"
      />

      <div>
        {{ formattedDate }}
      </div>
    </div>
  </div>
</template>
